export const NURSE_APPLICATION = {
  masterTableName: "MC_PAIN_ASS_SCORE_NURSE_APP ",
  tableName: "MC_PAIN_ASS_SCORE_NURSE_APP",
  columnName: "MCPASD_ID",
  columnValue: 0,
  title: "nurse-application-record.title",
  rows: [],
  fields: [],
  mcpConfig: {
    NON_MEDICAL_APP: {
      mcpId: 956,
      field: "NON_MEDICAL_APP",
      scoreField: "NON_MEDICAL_APP_XVALUE",
    },
    ATTEMPTS_MADE: {
      mcpId: 160,
      field: "ATTEMPTS_MADE",
      scoreField: "ATTEMPTS_MADE_XVALUE",
    },
    SIDE_EFFECTS: {
      mcpId: 957,
      field: "SIDE_EFFECTS",
      scoreField: "SIDE_EFFECTS_XVALUE",
    },
    ACTIVITY_CONTROL: {
      mcpId: 958,
      field: "ACTIVITY_CONTROL",
      scoreField: "ACTIVITY_CONTROL_XVALUE",
    },
  } as Record<string, { mcpId: number; field: string; scoreField: string }>,
  formData: {
    ID: "",
    CTIME: new Date(),
    CHOUR: new Date(),
    NON_MEDICAL_APP: "",
    ATTEMPTS_MADE: "",
    SIDE_EFFECTS: "",
    ACTIVITY_CONTROL: "",
    PAIN_SCORE: "",
    NURSE_EXPLANATION: "",
    CUSER: "",
  },
};
